var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_5004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5.54774C15.8231 5.72462 15.6516 5.88543 15.4854 6.03015C15.3193 6.17487 15.1424 6.30084 14.9548 6.40804C14.7672 6.51524 14.5715 6.59296 14.3678 6.64121C14.1642 6.68945 13.9256 6.71893 13.6523 6.72965C13.47 6.72965 13.2958 6.71357 13.1296 6.68141L10.0824 9.72864C10.1521 9.93233 10.203 10.1414 10.2352 10.3558C10.2673 10.5702 10.2834 10.7846 10.2834 10.999C10.2834 11.3474 10.2486 11.6637 10.1789 11.9477C10.1092 12.2318 10.01 12.4998 9.88141 12.7518C9.75276 13.0037 9.59196 13.2422 9.39899 13.4673C9.20603 13.6925 8.9943 13.9256 8.76382 14.1668L5.6603 11.0633L1.09347 15.6382L0 16L0.361809 14.9065L4.93668 10.3397L1.83317 7.23618C2.06901 7.00033 2.2995 6.78861 2.52462 6.60101C2.74975 6.4134 2.98827 6.25528 3.2402 6.12663C3.49213 5.99799 3.76013 5.89615 4.04422 5.82111C4.32831 5.74606 4.64724 5.71122 5.00101 5.71658C5.21541 5.71658 5.42982 5.73266 5.64422 5.76482C5.85863 5.79698 6.06767 5.84791 6.27136 5.91759L9.31859 2.87035C9.28643 2.70419 9.27035 2.52998 9.27035 2.34774C9.27035 2.08509 9.29715 1.84925 9.35075 1.6402C9.40436 1.43116 9.48476 1.23283 9.59196 1.04523C9.69916 0.857621 9.82245 0.683417 9.96181 0.522613C10.1012 0.361809 10.2647 0.187605 10.4523 0L16 5.54774Z",
    fill: "#736BD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_5004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinned);
export default __webpack_public_path__ + "static/media/pinned.578d8afb5cf0f502d5c21276251e7375.svg";
export { ForwardRef as ReactComponent };